module.exports = __webpack_public_path__ + "static/NoNeedforCapacity-de1a922b7dcbab9caef730b64878d798.svg";